import DealerTableFilter from "./dealer-table-filter";


const DealerFilters = {
    Table: DealerTableFilter,
}

export default DealerFilters;